module.exports = __webpack_public_path__ + "img/ct.a2dbd8ae.jpg";